export enum SmsPreference {
    ALL = 'ALL',
    INFORMATIONAL_ONLY = 'INFORMATIONAL_ONLY',
    NONE = 'NONE',
}
